<template>
  <router-view v-if="hasAccess" />
  <PageLayout v-else :title="title">
    <PagePlaceholder :config="placeholderConfig" />
  </PageLayout>
</template>

<script>
import PageLayout from '@/components/layouts/PageLayout.vue';
import PagePlaceholder from '@/components/basic/placeholders/PagePlaceholder.vue';

export default {
  name: 'PermissionGate',
  components: { PageLayout, PagePlaceholder },
  props: {
    permission: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    placeholderTitle: {
      type: String,
      default: 'Access Required',
    },
    placeholderText: {
      type: String,
      default: 'Your assigned role does not include access to this section.',
    },
  },
  computed: {
    hasAccess() {
      return this.hasPermission(this.permission);
    },
    placeholderConfig() {
      return {
        title: this.placeholderTitle,
        text: this.placeholderText,
      };
    },
  },
};
</script>
